import { Plus } from 'lucide-react';
import { PermissionGate } from '../../../../auth/PermissionGate';

/**
 * Add a tier from the chart itself.
 *
 * Gated on the catalog's own create key, so a caller who may not add a tier is offered
 * nothing rather than a button that 403s.
 *
 * **A new tier gets no lane until a unit carries it.** Lanes are drawn from the units on
 * screen, so the column appears the moment the first unit is filed under the new tier — the
 * same rule that stops an unused tier taking a column of empty space.
 */
export function AddTierButton({ onClick }: { onClick: () => void }) {
  return (
    <PermissionGate permission="org-unit-types.create">
      <button
        type="button"
        id="org-chart-add-tier"
        onClick={onClick}
        className="flex shrink-0 items-center gap-1 rounded-md border border-dashed border-slate-300 px-2 py-1 text-xs text-slate-500 transition hover:border-slate-400 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-200"
      >
        <Plus className="h-3 w-3" aria-hidden="true" />
        Tier
      </button>
    </PermissionGate>
  );
}
